import { memo } from 'react';

import { PrivateWorkspaceAgentPanelReferencePillChip } from '~/components/v2/components/workspace/workspace-agent-panel/components/messages/PrivateWorkspaceAgentPanelReferencePillChip';
import { PrivateWorkspaceAgentTablePillChip } from '~/components/v2/components/workspace/workspace-agent-panel/components/table-moniker/PrivateWorkspaceAgentTablePillChip';
import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';

export type PrivateWorkspaceAgentPanelMessagePillChipProps = {
  /** Mid-stream, a moniker with no pill yet is not a broken reference. */
  isStreaming: boolean;
  pill: WorkspaceAgentMessagePill | undefined;
  rawId: string;
};

export const PrivateWorkspaceAgentPanelMessagePillChip = memo(
  ({ isStreaming, pill, rawId }: PrivateWorkspaceAgentPanelMessagePillChipProps) => {
    if (pill?.type === 'table') {
      return <PrivateWorkspaceAgentTablePillChip isStreaming={isStreaming} pill={pill} />;
    }

    return <PrivateWorkspaceAgentPanelReferencePillChip isStreaming={isStreaming} pill={pill} rawId={rawId} />;
  },
);

PrivateWorkspaceAgentPanelMessagePillChip.displayName = 'PrivateWorkspaceAgentPanelMessagePillChip';
